function pipe(value, ...fns) {
    return fns.reduce((acc, fn)=>fn(acc), value);
}
export { pipe };
